import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { usePostHog } from '@posthog/react'
import OnboardingPopup from '../OnboardingPopup'
import './OnboardingView.css'

export const ONBOARDING_STATUS_KEY = 'myscribbl_onboarding_status'
const CALL_START_TIME_KEY = 'myscribbl_onboarding_call_start'

export type OnboardingStatus =
  | 'pending'
  | 'calling'
  | 'call_done'
  | 'results_ready'
  | 'complete'
  | 'skipped'

type Props = {
  userId: string | null
  status: string
}

function OnboardingView({ userId, status }: Props) {
  const posthog = usePostHog()
  const navigate = useNavigate()
  console.log('Onboarding status:', status)

  const transition = useCallback((next: OnboardingStatus) => {
    localStorage.setItem(ONBOARDING_STATUS_KEY, next)
  }, [])

  const handleSkip = () => {
    posthog?.capture('onboarding_skipped', { user_id: userId })
    localStorage.removeItem(CALL_START_TIME_KEY)
    transition('skipped')
  }

  const handleComplete = () => {
    posthog?.capture('onboarding_completed', { user_id: userId })
    localStorage.removeItem(CALL_START_TIME_KEY)
    transition('complete')
    navigate('/', { replace: true })
  }

  return (
    <OnboardingPopup
      open={true}
      userId={userId}
      onClose={handleSkip}
      onComplete={handleComplete}
    />
  )
}

export default OnboardingView
